import type { FaireProductEntity } from "../../entity_types/product";

export const p_s3ke2vfab6: FaireProductEntity = {
  token: "p_s3ke2vfab6",
  type: "product",
  name: "Wholesale Lot 1 lb Natural Blue Chalcedony Tumble Healing",
  brandToken: "b_edj9u7j4sq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d082d95674217cdf8eb730915b303ba311a077d47f5cc78d5b0b4c8736a6b816.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/646502350e4ab09ae4a8052af374e3cfed872eb141fb172efddefe617b5760b8.png",
    "https://cdn.faire.com/fastly/442d3a1a208edd38ce2bf603dcdaf44cde0b76a46b7876a4ae305ff65c25e11f.jpeg",
    "https://cdn.faire.com/fastly/569220292556aa8c587a6736d09b8fb485cbeeaef9f3d38645a3914b33848034.png",
  ],
  priceDollars: 97,
  description:
    "Wholesale Lot 1 lb Natural Blue Chalcedony Tumble. Blue Chalcedony is found is Uruguay. Condition is New. Free local pickup in Brooklyn, New York. Stones, stone wholesale, crystals, crystal bulk, crystal wholesale, spiritual, spiritual items, meditation, metaphysical wholesale. ",
  tags: [],
  msrpDollars: 194,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:27.106Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
